import { useState } from "react";
import { X } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { ChoiceExercise } from "@/components/exercises/ChoiceExercise";
import { TextExercise } from "@/components/exercises/TextExercise";

const LABELS = { mcq: "Choose the right answer", listen: "Listen and choose", fill_blank: "Fill in the blank", translate: "Translate" };

export const QuizRunner = ({ questions, lang, onSubmit, onExit, submitting }) => {
  const [idx, setIdx] = useState(0);
  const [answers, setAnswers] = useState(() => questions.map(() => ""));
  const q = questions[idx];
  const isChoice = q.type === "mcq" || q.type === "listen";
  const Comp = isChoice ? ChoiceExercise : TextExercise;
  const last = idx === questions.length - 1;

  const setAnswer = (v) => setAnswers((a) => a.map((x, i) => (i === idx ? v : x)));
  const next = () => (last ? onSubmit(answers) : setIdx(idx + 1));

  return (
    <div className="max-w-2xl mx-auto pb-16">
      <div className="flex items-center gap-4 mb-8">
        <button data-testid="quiz-exit-button" onClick={onExit} className="text-slate-400 hover:text-slate-700"><X /></button>
        <Progress data-testid="quiz-progress" value={(idx / questions.length) * 100} className="h-3 flex-1" />
        <span data-testid="quiz-counter" className="text-sm font-bold text-slate-500">{idx + 1}/{questions.length}</span>
      </div>
      <div key={idx} className="animate-fade-up" data-testid={`quiz-question-${q.type}`}>
        <p className="caption mb-2">{LABELS[q.type]}</p>
        {isChoice && <h2 className="font-display text-2xl font-bold text-slate-900 mb-6">{q.prompt}</h2>}
        <Comp ex={q} lang={lang} locked={false} onChange={setAnswer} />
      </div>
      <button
        data-testid={last ? "quiz-submit-button" : "quiz-next-button"}
        disabled={!answers[idx]?.trim() || submitting}
        onClick={next}
        className="btn-primary w-full mt-8"
      >
        {last ? (submitting ? "Scoring..." : "Submit answers") : "Next"}
      </button>
      {!isChoice && !last && (
        <button data-testid="quiz-skip-button" onClick={() => { setAnswer(" "); setIdx(idx + 1); }} className="w-full mt-3 text-sm font-semibold text-slate-500 hover:text-slate-800">
          I don't know, skip
        </button>
      )}
    </div>
  );
};
